var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.533 2.23C14.777.78 13.41 0 12 0c-1.41 0-2.777.779-3.533 2.23L.527 17.46a4.667 4.667 0 0 0 0 4.31C1.183 23.027 2.448 24 4.061 24h15.878c1.613 0 2.878-.973 3.534-2.23a4.667 4.667 0 0 0 0-4.31l-7.94-15.23zm-5.293.925C10.66 2.349 11.352 2 12 2c.648 0 1.34.35 1.76 1.155l7.94 15.23a2.667 2.667 0 0 1 0 2.46c-.374.717-1.02 1.155-1.76 1.155H4.06c-.74 0-1.386-.438-1.76-1.155a2.667 2.667 0 0 1 0-2.46l7.94-15.23zM12 7a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1zm0 12.25c-.69 0-1.25-.56-1.25-1.25v-.01a1.25 1.25 0 0 1 2.5 0V18c0 .69-.56 1.25-1.25 1.25z",
    fill: "#D42F42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDanger);
export default __webpack_public_path__ + "static/media/icn_danger.wtn-site.svg";
export { ForwardRef as ReactComponent };